import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { MuiDialog, MuiBox, MuiTypography } from 'theme/material-ui';
import { Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { FontSize } from 'modules/styles/variables';
import { MarginMuiBox } from '../styled';
import { Color } from 'modules/styles/colors';
import { PaymentFormField } from '../types';
import { LOCATION_STATES } from 'modules/constants/LocationStates';
import StyledButton from 'components/UI/Button/StyledButton';
import Spacer from 'components/UI/Layout/Spacer';
import { InputField } from 'components/UI/Input/TextInput';
import SelectField from 'components/PreRegister/FormFields/SelectField';
import { PreRegHeader } from '../common';
import RequiredFieldsLegend, { StyledAsterisk } from 'components/RequiredFieldsLegend';

type Props = {
  closePopup: Function;
  formField: PaymentFormField;
};

const Transition = React.forwardRef<unknown, TransitionProps>((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export const CreditCardModel = (props: Props) => {
  const {
    closePopup,
    formField: {
      cardNumber,
      cardExpiration,
      cardCvv,
      firstName,
      lastName,
      address1,
      address2,
      city,
      state,
      zipCode
    }
  } = props;
  const [open, setOpen] = React.useState(false);

  useEffect(() => setOpen(true), []);

  const handleClose = () => {
    setOpen(false);
    closePopup(false);
  };

  return (
    <MuiDialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <MuiBox flexDirection="column" alignContent="center">
        <PreRegHeader title="Payment Method" handleClose={handleClose} />

        <MarginMuiBox pt={1} flexDirection="column">
          <RequiredFieldsLegend />
          <MuiTypography fontSize={FontSize.medium}>
            Card Number <StyledAsterisk />
          </MuiTypography>
          <InputField
            autoComplete="cc-number"
            name={cardNumber.name}
            label={cardNumber.label}
            fullWidth
          />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Expiration Date (MM/YY) <StyledAsterisk />
          </MuiTypography>
          <InputField
            autoComplete="cc-exp"
            name={cardExpiration.name}
            label={cardExpiration.label}
            fullWidth
          />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            CVV <StyledAsterisk />
          </MuiTypography>
          <InputField autoComplete="cc-csc" name={cardCvv.name} label={cardCvv.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            First Name <StyledAsterisk />
          </MuiTypography>
          <InputField name={firstName.name} label={firstName.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Last Name <StyledAsterisk />
          </MuiTypography>
          <InputField name={lastName.name} label={lastName.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Billing Address <StyledAsterisk />
          </MuiTypography>
          <InputField name={address1.name} label={address1.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>Billing Address Line 2</MuiTypography>
          <InputField name={address2.name} label={address2.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            City <StyledAsterisk />
          </MuiTypography>
          <InputField name={city.name} label={city.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            State <StyledAsterisk />
          </MuiTypography>
          <SelectField name={state.name} label={state.label} data={LOCATION_STATES} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Zip Code <StyledAsterisk />
          </MuiTypography>
          <InputField name={zipCode.name} label={zipCode.label} fullWidth />
        </MarginMuiBox>
      </MuiBox>
      <MuiBox m={1} p={1} flexDirection="row">
        <StyledButton onPress={handleClose}>Confirm</StyledButton>
      </MuiBox>
    </MuiDialog>
  );
};

CreditCardModel.defaultProps = {
  closePopup: () => {}
};

export default connect()(CreditCardModel);
